
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
//types
// Endpoints
import { SUBSCRIPTION_INVOICES } from '@/routes/privateRoutes';
// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';
import useUser from '@/utils/hooks/swr/useUser';
import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';
// Components
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import SettingsWrapper from '@/components/layouts/LayoutPlatform/components/SettingsWrapper';
import HeaderSettings from '@/components/pages/settings/HeaderSettings';
import WrapperSettings from '@/components/pages/settings/WrapperSettings';
import { Content } from '@/components/pages/settings/subscription-invoices/PageContent';
const PricingModal = dynamic(() => import('@/components/pages/settings/subscription-invoices/PlanModal').then((el) => el.PricingModal));
const PageContent = () => {
    const { isTreeStructureActivated } = useActiveTreeStructure();
    const { isOpen: isOpenPlanModal, toggle: togglePlanModal } = useToggle();
    const { user } = useUser();
    const router = useRouter();
    const { clearUrlQueriesWithoutReload } = useRouterQuery();
    const { step } = router.query;
    useEffect(() => {
        if (!step || step !== 'change_your_plan' || user.past_due) {
            return;
        }
        if (isOpenPlanModal) {
            return;
        }
        togglePlanModal();
        clearUrlQueriesWithoutReload();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [step]);
    if (isTreeStructureActivated) {
        return (<SettingsWrapper>
                <Content togglePlanModal={togglePlanModal}/>
                <PricingModal isOpen={isOpenPlanModal} toggle={togglePlanModal}/>
            </SettingsWrapper>);
    }
    return (<>
            <HeaderSettings current={SUBSCRIPTION_INVOICES}/>
            <WrapperSettings>
                <Content togglePlanModal={togglePlanModal}/>
            </WrapperSettings>
            <PricingModal isOpen={isOpenPlanModal} toggle={togglePlanModal}/>
        </>);
};
const SubscriptionInvoices = () => (<WrapperSwitchLayout noPadding={true} disableMainScroll={true}>
        <PageContent />
    </WrapperSwitchLayout>);
export default SubscriptionInvoices;

    async function __Next_Translate__getStaticProps__193b0d828ae__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/settings/subscription-invoices',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__193b0d828ae__ as getStaticProps }
  